<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left" title="Volver"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" (click)="saveEmbalaje()" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>    

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Embalaje {{codigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudEx}}">{{codigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloEstadoSolicitudEx}}" />
                <img *ngIf="IdSubTipoSolicitudEx === tercerPaisConAtestFito || IdSubTipoSolicitudEx === reExpConAtestFito || IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="row">
                    <!--DATOS BASICOS -->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDatosBasicos = !isCollapsedDatosBasicos" [attr.aria-expanded]="!isCollapsedDatosBasicos" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos básicos
                                    <i *ngIf="isCollapsedDatosBasicos" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosBasicos" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosBasicos" [ngbCollapse]="isCollapsedDatosBasicos">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Código Táric</label>
                                            <ng-select class="ngselect-listbox-no-button"
                                                       [(items)]="listTaric"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTaric"
                                                       loadingText="Cargando..."
                                                       [loading]="!listTaric"
                                                       notFoundText="Cód. Táric no encontrado"
                                                       placeholder="-- Seleccione un Cód. Táric --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdTaric')"
                                                       (change)="onSelectTaric()">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTaric','required')">
                                                Código Táric es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Código Eppo</label>
                                            <ng-select class="ngselect-listbox-no-button"
                                                       [(items)]="listEppo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdEppo"
                                                       loadingText="Cargando..."
                                                       [loading]="!listEppo"
                                                       notFoundText="Cód. Eppo no encontrado"
                                                       placeholder="-- Seleccione un Cód. Eppo --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdEppo')">                                                
                                            </ng-select>                                            

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdEppo','required')">
                                                Código Eppo es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">Unidades</label>
                                            <ng-select class="ngselect-listbox-no-button"
                                                       [(items)]="listUnidad"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdUnidad"
                                                       loadingText="Cargando..."
                                                       [loading]="!listUnidad && (form.value.IdTaric !== null)"
                                                       notFoundText="Unidad no encontrada"
                                                       placeholder="-- Seleccione una Unidad --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdUnidad')">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>                                            

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUnidad','required')">
                                                Unidad es obligatoria
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpDescripcion">Nº de Bultos</label>
                                            <input formControlName="Recuento" numbersOnly name="Recuento" [ngClass]="displayFieldCss('Recuento')" maxlength="10" title="" class="form-control" id="inpNombre" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Recuento','required')">
                                                Nº de Bultos es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intEstado">País Origen</label>

                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPais"
                                                       loadingText="Cargando..."
                                                       [loading]="!listPais"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPais')">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                                País Origen es obligatorio
                                            </div>
                                        </div>

                                    </div>                                    

                                </div>
                            </div>
                        </div>
                    </div>
                </div>                

            </div>

        </div>

    </div>

</form>


